import { ContactsOutlined, SendOutlined } from "@ant-design/icons";
import { Button, Col, Typography } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import Typical from "react-typical";

const steps = [
  "I am Front-End Developer ",
  1000,
  "I am Back-End Developer ",
  1000,
  "I am Mern-Stack Developer ",
  1000,
];
const { Title, Paragraph, Text } = Typography;

const HeroTitle = ({ heroTitle }) => {
  const { name, description, intro } = heroTitle;
  return (
    <>
      <Col xs={23} sm={22} md={18} lg={16} xl={14} xxl={12}>
        <Title style={{ color: "#fff" }}>
          {" "}
          <Text style={{ fontSize: "2rem", color: "#ffd" }}>
            {" "}
            {intro}{" "}
          </Text>{" "}
          <br /> {name}
        </Title>
        <Title level={3} style={{ color: "#FFF" }}>
          <Typical wrapper="span" steps={steps} loop={Infinity} />
        </Title>
        <Paragraph style={{ color: "#fff" }}>{description}</Paragraph>
        <Button.Group>
          <a
            href="https://drive.google.com/file/d/1OM7DonCvZ7TEdMOgVD6xheHVyLhK1CIT/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            <Button type="primary" size="large">
              <SendOutlined /> Download Resume{" "}
            </Button>{" "}
          </a>
          <Link to="/Contact">
            {" "}
            <Button type="primary" size="large" danger>
              {" "}
              <ContactsOutlined /> Get In Touch{" "}
            </Button>{" "}
          </Link>
        </Button.Group>
      </Col>
    </>
  );
};

export default HeroTitle;
